import * as yup from "yup";

const inviteProviderSchema = yup.object().shape({
  providerEmail: yup
    .string()
    .email("Enter a valid email")
    .required("Email must not be blank"),
});

export default inviteProviderSchema;
